export default __webpack_public_path__ + "static/media/hatchback.a41ae84a.svg";